import React from 'react';
import { useI18n } from '../../i18n';

export const WHATSAPP_SUPPORT_URL = 'https://wa.me/966530631509';
const SUPPORT_PHONE = '0530631509';

function WhatsAppIcon({ className }: { className: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" className={className}>
      <path d="M20.52 3.48A11.91 11.91 0 0 0 12.05 0C5.46 0 .1 5.36.1 11.95c0 2.1.55 4.15 1.6 5.96L0 24l6.25-1.64a11.9 11.9 0 0 0 5.8 1.48h.01c6.58 0 11.94-5.36 11.94-11.95a11.87 11.87 0 0 0-3.48-8.41Zm-8.47 18.35a9.9 9.9 0 0 1-5.05-1.38l-.36-.21-3.71.97.99-3.62-.24-.37a9.88 9.88 0 0 1-1.52-5.27c0-5.48 4.46-9.94 9.94-9.94a9.87 9.87 0 0 1 7.04 2.92 9.88 9.88 0 0 1 2.91 7.04c0 5.48-4.46 9.94-9.94 9.94Zm5.45-7.44c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.18.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.49s1.07 2.89 1.22 3.09c.15.2 2.1 3.2 5.09 4.49.71.31 1.26.49 1.69.63.71.23 1.35.2 1.86.12.57-.09 1.77-.72 2.01-1.42.25-.7.25-1.3.18-1.42-.08-.13-.28-.2-.57-.35Z" />
    </svg>
  );
}

/** Direct click-to-chat only: no widget SDK, automatic messages or tracking. */
export function WhatsAppSupport({ floating = false }: { floating?: boolean }) {
  const { t } = useI18n();
  const linkProps = {
    href: WHATSAPP_SUPPORT_URL,
    target: '_blank',
    rel: 'noopener noreferrer',
  };

  if (floating) {
    return (
      <a
        {...linkProps}
        aria-label={t('help.whatsapp.action')}
        title={t('help.whatsapp.action')}
        className="fixed z-40 flex h-14 w-14 items-center justify-center rounded-full border-2 border-white bg-[#128C7E] text-white shadow-lg transition-colors hover:bg-[#075E54] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#128C7E]/40 focus-visible:ring-offset-2 motion-reduce:transition-none"
        style={{ bottom: 'calc(1rem + env(safe-area-inset-bottom, 0px))', right: 'calc(1rem + env(safe-area-inset-right, 0px))' }}
      >
        <WhatsAppIcon className="h-7 w-7" />
      </a>
    );
  }

  return (
    <section className="rounded-2xl border border-emerald-200 bg-emerald-50 p-4 sm:p-5">
      <div className="flex items-start gap-3">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#128C7E] text-white">
          <WhatsAppIcon className="h-6 w-6" />
        </div>
        <div className="min-w-0 flex-1">
          <h2 className="text-base font-semibold leading-relaxed text-[#434343]">{t('help.whatsapp.title')}</h2>
          <p className="mt-1 text-sm leading-relaxed text-[#434343]/80">{t('help.whatsapp.body')}</p>
          <p className="mt-2 text-sm font-medium text-[#075E54]"><bdi dir="ltr">{SUPPORT_PHONE}</bdi></p>
        </div>
      </div>
      <a
        {...linkProps}
        className="mt-4 inline-flex min-h-11 w-full items-center justify-center rounded-xl bg-[#128C7E] px-4 py-2.5 text-center text-sm font-medium leading-relaxed text-white transition-colors hover:bg-[#075E54] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#128C7E]/40 focus-visible:ring-offset-2 motion-reduce:transition-none sm:w-auto"
      >
        {t('help.whatsapp.action')}
      </a>
    </section>
  );
}
